import { Box, Container, Typography } from "@mui/material";
import * as React from "react";

export default function Login(props: any) {
  return (
    <React.Fragment>
      <Container maxWidth="xl">
        <Box>
          <Typography variant="body2">Login Page</Typography>
        </Box>
      </Container>
    </React.Fragment>
  );
}
